<template>
  <div>
    <aha-modal
      v-if="showList"
      width="640px"
      @hide="handleHideModal()"
      :title="titleChoosePresentation"
    >
      <div class="modal-body">
        <!-- Mobile view -->
        <!-- End Mobile view -->

        <!-- Desktop view -->
        <div
          v-if="loadingPresentation"
          class="flex justify-center items-center h-12"
        >
          <aha-spinner />
        </div>
        <div v-else>
          <table
            class="hidden main-table md:table"
            v-if="presentations.length > 0"
          >
            <thead>
              <tr>
                <table-heading name="checkbox" class="w-1 pl-4 pr-4">
                </table-heading>
                <table-heading name="thumbnail">
                  <span class="font-bold">
                    <span>{{ $i18nPresenter.t('Name') }}</span>
                  </span>
                </table-heading>
                <table-heading name="name" />
                <table-heading class="text-center" name="updatedAt">
                  <span class="font-bold">
                    <span>{{ $i18nPresenter.t('Last Updated') }}</span>
                  </span>
                </table-heading>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-row relative cursor-pointer"
                v-for="(presentation) in presentations"
                :class="[publishIDList.includes(presentation.id) ? 'row-active' : 'row-default']"
                :key="`presentation-${presentation.id}`"
                @click="handleRowClicked(presentation)"
              >
                <table-data
                  name="checkbox"
                  class="w-1 pl-4 pr-2 py-3 main-table--table-cell"
                >
                  <aha-checkbox
                    :checked="publishIDList.includes(presentation.id)"
                    @change="handlePresentationSelect(presentation, $event)"
                  />
                </table-data>
                <table-data
                  name="thumbnail"
                  class="main-table--thumbnail main-table--table-cell"
                >
                  <presentation-thumbnail :presentation="presentation" />
                </table-data>
                <table-data
                  name="name"
                  class="main-table--item-name text-link main-table--table-cell mt-2"
                >
                  <PresentationInfo :presentation="presentation" />
                </table-data>
                <table-data
                  name="updatedAt"
                  class="text-xs text-center cursor-pointer lg:w-36 main-table--table-cell"
                >
                  <aha-formatter
                    :value="presentation.updatedAt"
                    type="date"
                    showTooltip
                    :tooltipValue="presentation.updatedAt | dateTime"
                    :locale="locale"
                  />
                </table-data>
              </tr>
            </tbody>
          </table>
          <p
            v-if="presentations.length === 0"
            class="text-center m-4 xs:m-8"
          >
            {{ getNoDataMessage }}
          </p>
        </div>
        <!-- End desktopview -->
      </div>
      <template #action>
        <span class="pr-4">
          {{
            $i18nPresenter.t(`Any AhaSlides user can get a copy of this presentation,` +
              ` with your notes, from the Template Library.`)
          }}
          <a
            href="#"
            @click.prevent="clickLearnMore()"
            id="learn-more"
          >{{ $i18nPresenter.t('Learn more...') }}
          </a>
        </span>
        <aha-button
          variant="primary"
          @click="handlePublishPresentations()"
          :disabled="isDisablePublishButton"
          :submitting="publishing"
          class="w-32"
        >
          {{ $i18nPresenter.t('Publish') }}
        </aha-button>
      </template>
    </aha-modal>
    <SuccessPublishPresentations
      :hide="handleHideModal"
      v-if="!showList"
      :forceCongratMode="true"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import PresentationInfo from '@/components-v2/my-presentations/main-table/PublishPresentationInfo.vue'
import PresentationThumbnail from '@/components-v2/my-presentations/main-table/PresentationThumbnail.vue'
import SuccessPublishPresentations from './SuccessPublishPresentations'
import TableData from '@/components-v2/my-presentations/main-table/TableData.vue'
import TableHeading from '@/components-v2/my-presentations/main-table/TableHeading.vue'
import CommunityApi from '@/api/community'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
    SuccessPublishPresentations,
    PresentationInfo,
    PresentationThumbnail,
    TableData,
    TableHeading,
  },
  data: () => {
    return {
      publishIDList: [],
      showList: true,
      publishing: false,
      presentations: [],
      total: 0,
      loadingPresentation: true,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.presenterLocale,
    }),
    titleChoosePresentation() {
      return this.$i18nPresenter.t('Choose presentation(s)')
    },
    isDisablePublishButton() {
      if (this.publishIDList.length > 0) return false
      return true
    },
    getNoDataMessage() {
      if (this.total === 0) return this.$i18nPresenter.t('You have no presentations to show')
      return this.$i18nPresenter.t('You have published all of your presentations')
    },
  },
  async mounted() {
    const data = await CommunityApi.getAllNotPublishedPresentation()
    this.presentations = data.docs || []
    this.total = data.numberOfPresentations || 0
    this.loadingPresentation = false
  },
  methods: {
    ...mapActions('presentationTemplates', ['getNewlyAddedAction']),
    ...mapActions('patchPresentationAction'),
    handleHideModal() {
      this.showList = true
      this.publishIDList = []
      this.$emit('hide')
    },
    async handlePublishPresentations() {
      this.publishing = true
      await CommunityApi.publishPresentation({
        presentationIds: this.publishIDList,
      })
      await this.getNewlyAddedAction()
      this.publishing = false
      this.showSuccessModal()
      utils.mixpanelTracking('Template Library', 'Publish successfully', this.publishIDList.length.toString(), this.publishIDList.toString())
    },
    handlePresentationSelect(changedPresentation, evt) {
      const { id } = changedPresentation
      const index = this.publishIDList.indexOf(id)
      if (evt) {
        if (index === -1) this.publishIDList.push(changedPresentation.id)
      } else {
        this.publishIDList.splice(index, 1)
      }
    },
    handleRowClicked(clickedPresentation) {
      const { id } = clickedPresentation
      const index = this.publishIDList.indexOf(id)
      if (index !== -1) {
        this.publishIDList.splice(index, 1)
      } else {
        this.publishIDList.push(id)
      }
    },
    showSuccessModal() {
      this.showList = false
    },
    clickLearnMore() {
      utils.mixpanelTracking(eventCategories.TEMPLATE_LIBRARY, 'Open Share menu > Learn more')
      window.open('https://help.ahaslides.com/portal/en/kb/articles/publishing-your-presentation-to-ahaslides-template-library', '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.main-table {
  @apply border-separate w-full;
  border-spacing: 0 0.5rem;
}

.main-table tbody tr {
  @apply text-base-80;
  &:hover {
    @apply ring-1;
  }
}
.row-default {
  box-shadow: 1px 1px 2px 1px #cecece;
}
.row-active {
  @apply ring-1;
}

.main-table td.main-table--table-cell:first-child {
  @apply rounded-l-lg border-l;
}

.main-table td.main-table--table-cell:last-child {
  @apply rounded-r-lg border-r;
}

.main-table--thumbnail {
  @apply w-20;
}

.main-table--item-name {
  @apply ml-4 font-bold truncate transition-colors 2xs:max-w-64;

}
.modal-body {
  max-height: 25rem;
}

#learn-more {
  color: #348ef6;
}
</style>
